export default {
  SEARCH: "q",
  TIME_MIN: "timeMin",
  TIME_MAX: "timeMax",
  SHOW_DELETED: "showDeleted",
  SINGLE_EVENTS: "singleEvents"
};
